import React, { useRef } from 'react';
import { Button } from 'src/common/button';
import { Node } from 'src/common/interfaces/node.interface';
import { functionNoop } from 'src/utils/function/noop';
import { WizardContentLibrarySlideOver } from '../library-slide-over';
import { WizardContentSectionTemplate } from './template';

export interface WizardContentSectionLibraryProps {
  onSelectContent: (node: Node) => void;
}

export const WizardContentSectionLibrary = ({ onSelectContent }: WizardContentSectionLibraryProps) => {
  const pickFromLibraryOpenRef = useRef(functionNoop);
  const pickFromLibraryCloseRef = useRef(functionNoop);

  return (
    <>
      <WizardContentSectionTemplate
        title='Library'
        className='border-b-transparent'
        description='If you’ve used content within Journey before - reuse it.'
      >
        <Button
          label='Pick content'
          variant='secondary'
          size='regular'
          onClick={() => {
            pickFromLibraryOpenRef.current();
          }}
        />
      </WizardContentSectionTemplate>
      <WizardContentLibrarySlideOver
        openRef={pickFromLibraryOpenRef}
        closeRef={pickFromLibraryCloseRef}
        onSelectContent={onSelectContent}
      />
    </>
  );
};
